/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest = {
  /**
   * The user_session_issuer id.
   */
  id: string;
  /**
   * True to preview moving onto the authentication host, false to preview moving off it.
   */
  useAuthenticationHost: boolean;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity$Outbound =
  {
    "session_header_Gram-Session"?: string | undefined;
  };

/** @internal */
export const GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity$outboundSchema:
  z.ZodMiniType<
    GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity$Outbound,
    GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getOrganizationUserSessionIssuerAuthenticationHostImpactSecurityToJSON(
  getOrganizationUserSessionIssuerAuthenticationHostImpactSecurity:
    GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity,
): string {
  return JSON.stringify(
    GetOrganizationUserSessionIssuerAuthenticationHostImpactSecurity$outboundSchema
      .parse(getOrganizationUserSessionIssuerAuthenticationHostImpactSecurity),
  );
}

/** @internal */
export type GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest$Outbound =
  {
    id: string;
    use_authentication_host: boolean;
    "Gram-Session"?: string | undefined;
  };

/** @internal */
export const GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest$outboundSchema:
  z.ZodMiniType<
    GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest$Outbound,
    GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest
  > = z.pipe(
    z.object({
      id: z.string(),
      useAuthenticationHost: z.boolean(),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        useAuthenticationHost: "use_authentication_host",
        gramSession: "Gram-Session",
      });
    }),
  );

export function getOrganizationUserSessionIssuerAuthenticationHostImpactRequestToJSON(
  getOrganizationUserSessionIssuerAuthenticationHostImpactRequest:
    GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest,
): string {
  return JSON.stringify(
    GetOrganizationUserSessionIssuerAuthenticationHostImpactRequest$outboundSchema
      .parse(getOrganizationUserSessionIssuerAuthenticationHostImpactRequest),
  );
}
